<template>
  <div>
    <NuxtPage />
    <VideoPopup />
  </div>
</template>

<script setup lang="ts">
import { useFooterSettings } from '@/state/footerSettings'
import { useHeaderSettings } from '@/state/headerSettings'
import { useWebsiteSettings } from '@/state/websiteSettings'

await useWebsiteSettings()
await useHeaderSettings()
await useFooterSettings()

const { data: seoSettings } = await useAsyncData('seoSettings', () =>
  useApi().publicCoreSeoSettingsRetrieve()
)

const preparedSEOHead = usePrepareSEOHead(seoSettings)

useHead({
  title: seoSettings.value?.meta_title,
  titleTemplate: seoSettings.value?.meta_title_template,
  ...preparedSEOHead
})
</script>
